import { Component } from '@angular/core';

import { ApSquareSkeletonComponent, ApParagraphSkeletonComponent } from '@ap/skeleton';

/**
 * @ngdoc component
 * @name ApNativeAppSkeletonComponent
 */
@Component({
    selector: 'ap-native-app-skeleton',
    standalone: true,
    templateUrl: './skeleton.component.html',
    styleUrls: ['./skeleton.component.scss'],
    imports: [ApSquareSkeletonComponent, ApParagraphSkeletonComponent]
})
export class ApNativeAppSkeletonComponent {}
